<script setup lang="ts">
import { reactive, shallowRef } from 'vue';
import AnimationList from '@/components/Animations/AnimationList.vue';
import PlayIcon from '@/assets/images/icons8-motion-35-black.svg?component';

import type { Component, ShallowRef } from 'vue';
import type { Nullable } from '@immersive-tech/viewer-engine';

interface IMenuItem {
  label: string;
  icon: ShallowRef<Component>;
  component: ShallowRef<Component>;
}

const activeComponent = shallowRef<Nullable<Component>>(null);
const menuItems = reactive<IMenuItem[]>([
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  { label: 'Animations', icon: shallowRef(PlayIcon), component: shallowRef(AnimationList) },
]);

const setActiveComponent = (component: Component) => {
  activeComponent.value = activeComponent.value === component ? null : component;
};
</script>

<template>
  <nav class="flex flex-col text-center mt-auto">
    <div
      v-for="menuItem in menuItems"
      :key="menuItem.label"
      class="flex flex-col items-center py-1 border-b rounded-sm last-of-type:mb-0 last-of-type:border-b-0 cursor-pointer"
      :class="`bg-${activeComponent === menuItem.component ? 'slate-300' : 'white'}`"
      @click="setActiveComponent(menuItem.component)"
    >
      <component :is="menuItem.icon" />
      <p class="text-xs mt-1">
        {{ menuItem.label }}
      </p>
    </div>
  </nav>
  <div v-if="activeComponent !== null" class="absolute bg-white max-h-[350px] max-w-[350px] h-max w-max border-r border-t p-1 z-10 left-[85px] bottom-0 overflow-auto">
    <component :is="activeComponent" />
  </div>
</template>
